import template from './editCustomerSection.html';
import controller from './editCustomerSection.controller';

let editCustomerSectionComponent = {
  restrict: 'E',
  bindings: {
    customer: '=',
    impersonationError: '=',
    exportError: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default editCustomerSectionComponent;



// WEBPACK FOOTER //
// ./app/components/editCustomerSection/editCustomerSection.component.js